import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  
  connect() {
    console.log("Dropdown controller connected!")
    this.closeHandler = this.close.bind(this)
  }
  
  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }
  
  open() {
    this.menuTarget.classList.remove("hidden")
    // Defer adding the click listener to avoid immediate close
    setTimeout(() => {
      document.addEventListener("click", this.closeHandler)
    }, 0)
    
    this.element.querySelector("button").setAttribute("aria-expanded", "true")
  }
  
  close(event) {
    if (event && this.element.contains(event.target)) {
      return
    }
    
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.closeHandler)
    
    this.element.querySelector("button").setAttribute("aria-expanded", "false")
  }
  
  disconnect() {
    document.removeEventListener("click", this.closeHandler)
  }
}